const NAVMENU = document.querySelector("#menu-nav");
const LOGINMENU = document.querySelector("#menu-login");
const SEARCHMENU = document.querySelector("#menu-search");
const accountModal = document.querySelector(".account-opening.modal") as HTMLElement;
var body = document.querySelector("body");

// Mobile Menu
function toggleNavMenu() {
    NAVMENU.classList.toggle("open");
    let loginButtons = document.querySelectorAll(".js-nav-button");
    Array.from(loginButtons).map((x) => x.classList.toggle("open"));
    body.classList.toggle("nav-menu-open");
}

// Login Menu
function toggleLoginMenu() {
    LOGINMENU.classList.toggle("open");
    let loginButtons = document.querySelectorAll(".js-login-button");
    Array.from(loginButtons).map((x) => x.classList.toggle("open"));
    body.classList.toggle("login-open");
}

// Search Menu
function toggleSearchMenu() {
    SEARCHMENU.classList.toggle("open");
    let loginButtons = document.querySelectorAll(".js-search-button");
    Array.from(loginButtons).map((x) => x.classList.toggle("open"));
    body.classList.toggle("search-open");
}

// Reset Open Menus when a submenu is opened, e.g.; Login button clicked in the Mobile Menu
function closeAllMenus(menuActivating) {
    let openMenus = document.querySelectorAll("section[id^=menu-].open");
    openMenus.forEach(function (menu) {
        if (menu != menuActivating) {
            let menuWord = menu.getAttribute("id").replace("menu-", "");
            switch (menuWord) {
                case "nav":
                    toggleNavMenu();
                    break;
                case "login":
                    toggleLoginMenu();
                    break;
                case "search":
                    toggleSearchMenu();
                    break;
            }
        }
    });
}

function closeModal(modal) {
    body.classList.remove(`${modal.dataset.type}-open`);
    modal.dataset.open = "false";
    const menu = body.querySelector(`#menu-${modal.dataset.type}`);
    if (menu) {
        menu.classList.remove("open");
    }
}

document.addEventListener("click", (e) => {
    const target = e.target as Element;
    if (target.matches(".js-nav-button")) {
        if (body.classList.contains("search-open")) {
            toggleSearchMenu();
            closeAllMenus(SEARCHMENU);
        } else if (body.classList.contains("login-open")) {
            toggleLoginMenu();
            closeAllMenus(LOGINMENU);
        } else {
            toggleNavMenu();
            closeAllMenus(NAVMENU);
        }
    } else if (target.matches(".js-login-button")) {
        // Login Menu
        toggleLoginMenu();
        closeAllMenus(LOGINMENU);
    } else if (target.matches(".js-search-button")) {
        // Login Menu
        toggleSearchMenu();
        closeAllMenus(SEARCHMENU);
    } else if (target.matches(".js-close-modal")) {
        const modal = getParentElementWithClass(target, "modal");
        closeModal(modal);
    } else if (target.matches(".modal")) {
        closeModal(target);
    } else if (target.matches('.js-open-account-modal')) {
		event.preventDefault();
		const applyButton = accountModal.querySelector('.apply-link') as HTMLAnchorElement;
        const teenButton = accountModal.querySelector('.teenlink') as HTMLAnchorElement;
		const targetButton = target as HTMLAnchorElement;
		if (applyButton) {
			applyButton.href = targetButton.href;
		}
        if (targetButton.dataset.teen != null) {
            teenButton.href = targetButton.dataset.teen;
        } else {
            teenButton.style.display = "none";
        }
		accountModal.dataset.open = "true";
	}
});
